if (!window.awUgcSliderLoaded) {
  window.awUgcSliderLoaded = true;

  const AW_UGC_PRELOAD_MARGIN = '400px';

  function armVideos(section) {
    const videos = Array.from(section.querySelectorAll('[data-aw-ugc-video]'));
    if (!videos.length) return null;

    videos.forEach((video) => {
      video.addEventListener('click', () => {
        if (video.paused) {
          video.autoplay = true;
          const promise = video.play();
          if (promise && promise.catch) promise.catch(() => {});
        } else {
          video.autoplay = false;
          video.pause();
        }
      });
    });

    if (section.dataset.awUgcVideoAutoplay !== 'true') return null;

    const arm = (video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.autoplay = true;
      video.preload = 'auto';
      video.load();
    };

    if (!('IntersectionObserver' in window)) {
      videos.forEach(arm);
      return null;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);
          arm(entry.target);
        });
      },
      { rootMargin: AW_UGC_PRELOAD_MARGIN }
    );

    videos.forEach((video) => observer.observe(video));
    return observer;
  }

  function setupSlider(section) {
    const track = section.querySelector('[data-aw-ugc-track]');
    if (!track) return null;

    const cards = Array.from(track.children);
    const prev = section.querySelector('[data-aw-ugc-prev]');
    const next = section.querySelector('[data-aw-ugc-next]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoScroll = section.dataset.awUgcAutoplay === 'true';
    const interval = Number(section.dataset.awUgcInterval) || 5000;
    const behavior = reduceMotion ? 'auto' : 'smooth';
    let timer = null;

    const step = () => {
      if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
      return track.clientWidth;
    };

    const pageSize = () => {
      const one = step();
      return one * Math.max(1, Math.floor(track.clientWidth / one));
    };

    const maxScroll = () => track.scrollWidth - track.clientWidth;

    const updateArrows = () => {
      if (!prev && !next) return;
      const max = maxScroll();
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = max <= 1 || track.scrollLeft >= max - 1;
    };

    const move = (direction) => {
      track.scrollBy({ left: pageSize() * direction, behavior });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (timer || !autoScroll || reduceMotion || maxScroll() <= 1) return;
      timer = window.setInterval(() => {
        if (track.scrollLeft >= maxScroll() - 1) track.scrollTo({ left: 0, behavior });
        else move(1);
      }, interval);
    };

    if (prev) {
      prev.addEventListener('click', () => {
        move(-1);
        stop();
        start();
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        move(1);
        stop();
        start();
      });
    }

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);
    track.addEventListener('scroll', updateArrows, { passive: true });

    const onResize = () => updateArrows();
    window.addEventListener('resize', onResize, { passive: true });

    section.addEventListener(
      'toggle',
      (event) => {
        const panel = event.target;
        if (panel.tagName !== 'DETAILS' || !panel.open) return;
        section.querySelectorAll('details[open]').forEach((other) => {
          if (other !== panel) other.open = false;
        });
      },
      true
    );

    section.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = section.querySelector('details[open]');
      if (!open) return;
      open.open = false;
      const summary = open.querySelector('summary');
      if (summary) summary.focus();
    });

    updateArrows();
    start();

    return { stop, onResize };
  }

  function init(root) {
    (root || document).querySelectorAll('[data-aw-ugc-slider]').forEach((section) => {
      if (section.awUgcSlider) section.awUgcSlider.destroy();

      const observer = armVideos(section);
      const slider = setupSlider(section);

      section.awUgcSlider = {
        destroy() {
          if (observer) observer.disconnect();
          if (slider) {
            slider.stop();
            window.removeEventListener('resize', slider.onResize);
          }
        },
      };
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-aw-ugc-slider]');
    if (section && section.awUgcSlider) section.awUgcSlider.destroy();
  });
}